import Axios from 'axios';

import {
	GEPP_INSPECT_LOADING,
	GEPP_INSPECT_GET,
	GEPP_INSPECT_ERROR
} from './types';

import create_query_params from '../utils/create_query_params';

// Special-cased domains for the inspect endpoint. Most sources map to their
// last segment as-is (dropping the `gepp.` prefix); the plural→singular ones
// live here. Add more entries when new domains appear.
const DOMAIN_ALIAS = {
	censos: 'censo',
};

// Derive the inspection `domain` from `survey_response.source`:
//   "gepp.censos"  → "censo"
//   "gepp.refris"  → "refris"
//   "gepp.foo.bar" → "bar"  (last segment, no alias)
export const domainFromSource = (source) => {
	if (!source || typeof source !== 'string') return null;
	const segments = source.split('.');
	const last = segments[segments.length - 1];
	if (!last) return null;
	return DOMAIN_ALIAS[last] ?? last;
};

export const get_gepp_inspection = (domain, reference) => dispatch => {
	dispatch({ type: GEPP_INSPECT_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + '/api/gepp/inspect?';
	url += create_query_params({ domain, reference });

	Axios.get(url)
		.then((res) => {
			dispatch({ type: GEPP_INSPECT_GET, payload: res.data });
			dispatch({ type: GEPP_INSPECT_LOADING, payload: false });
		})
		.catch((err) => {
			dispatch({
				type: GEPP_INSPECT_ERROR,
				payload: { type: 'gepp_inspect', msg: err.message }
			});
			dispatch({ type: GEPP_INSPECT_LOADING, payload: false });
		});
};
